export const queryEnterprise = groq`*[ _type == "ABM" && currentPathname == $currentPathname][0]{
    ...,
  "abmHero": {
    title,
    subtitle,
    heroImage,
    ctaButtons,
},
}`;
